import { useState } from 'react';

const useDispatchWithSpinners = () => {
  const [callInProgress, setCallInProgress] = useState(false);

  const dispatchWithSpinner = async (call, params) => {
    setCallInProgress(true);
    try {
      let formattedParams = params;
      // Ensure params are in array so can spread over them
      if (!Array.isArray(params)) {
        formattedParams = [params];
      }
      const res = await call(...formattedParams);

      setCallInProgress(false);
      return res;
    } catch (e) {
      setCallInProgress(false);

      throw e;
    }
  };

  return {
    callInProgress,
    dispatchWithSpinner
  };
};

export default useDispatchWithSpinners;
